/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Time
 * @export
 * @interface Time
 */
export interface Time {
    /**
     * Hour part of the time data
     * @type {string}
     * @memberof Time
     */
    hour?: string;
    /**
     * Minute part of the time data
     * @type {string}
     * @memberof Time
     */
    minute?: string;
    /**
     * Formatted hour
     * @type {string}
     * @memberof Time
     */
    formattedHour?: string;
    /**
     * Meridiem indicator
     * @type {string}
     * @memberof Time
     */
    meridiemIndicator?: string;
}

/**
 * Check if a given object implements the Time interface.
 */
export function instanceOfTime(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TimeFromJSON(json: any): Time {
    return TimeFromJSONTyped(json, false);
}

export function TimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Time {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hour': !exists(json, 'hour') ? undefined : json['hour'],
        'minute': !exists(json, 'minute') ? undefined : json['minute'],
        'formattedHour': !exists(json, 'formattedHour') ? undefined : json['formattedHour'],
        'meridiemIndicator': !exists(json, 'meridiemIndicator') ? undefined : json['meridiemIndicator'],
    };
}

export function TimeToJSON(value?: Time | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hour': value.hour,
        'minute': value.minute,
        'formattedHour': value.formattedHour,
        'meridiemIndicator': value.meridiemIndicator,
    };
}

